import gql from 'graphql-tag'

export const RoLocations = gql`
	query roLocationsCollection($data: roLocationsFilter) {
		roLocationsCollection(filter: $data) {edges{node{
			id
			type
			name
			region2
		}}}
	}
`

export const AddCompanyLocations = gql`
	query addCompanyLocations($data: roLocationsFilter) {
		roLocationsCollection(filter: $data) {edges{node{
			id
			name
		}}}
	}
`
